import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { useTheme } from "@mui/material/styles"

import Column from "../../../common/components/Column"
import { recruitProfileNestedPanelSx } from "./recruitProfileSectionStyles"
import { formFieldsStackSx } from "./settingsFormStyles"

const STREET_CITY_FIELDS = [
  {
    key: "streetAddress",
    label: "Street Address",
    multiline: true,
    minRows: 2,
  },
  {
    key: "streetAddressPhonetics",
    label: "Street Address (phonetics)",
  },
  { key: "city", label: "Primary City" },
  { key: "cityPhonetics", label: "City Name Phonetics" },
  { key: "zipcode", label: "Zip Code" },
]

const LANDMARK_FIELDS = [
  {
    key: "localLandmark",
    label: "Intersection or local landmark",
    multiline: true,
    minRows: 2,
  },
  {
    key: "localLandmarkPhonetics",
    label: "Intersection or local landmark (phonetics)",
  },
]

function PanelLabel({ children }) {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontWeight: 700, letterSpacing: 0.4, display: "block" }}
    >
      {children}
    </Typography>
  )
}

/**
 * @param {object} props
 * @param {object} props.form
 * @param {function} props.patchForm
 * @param {boolean} props.disabled
 * @param {object} props.fieldErrors
 * @param {function} props.renderTextFields
 * @param {React.ReactNode} props.stateSelect
 * @param {React.ReactNode} props.timezoneSelect
 * @param {React.ReactNode} props.numberOfOfficesField
 */
export default function OfficeAddressFormSection({
  form,
  patchForm,
  disabled,
  fieldErrors,
  renderTextFields,
  stateSelect,
  timezoneSelect,
  numberOfOfficesField,
}) {
  const theme = useTheme()
  const panelSx = recruitProfileNestedPanelSx(theme)

  return (
    <Column sx={{ gap: 1.5, alignItems: "stretch" }}>
      <Box sx={panelSx}>
        <Column sx={formFieldsStackSx}>
          <PanelLabel>STREET & CITY</PanelLabel>
          {renderTextFields(
            STREET_CITY_FIELDS,
            form,
            patchForm,
            disabled,
            fieldErrors
          )}
          {stateSelect}
          {timezoneSelect}
        </Column>
      </Box>
      <Box sx={panelSx}>
        <Column sx={formFieldsStackSx}>
          <PanelLabel>LANDMARK & OFFICE COUNT</PanelLabel>
          {renderTextFields(
            LANDMARK_FIELDS,
            form,
            patchForm,
            disabled,
            fieldErrors
          )}
          {numberOfOfficesField}
        </Column>
      </Box>
    </Column>
  )
}
